import { createContext, useContext, useEffect, useState } from "react";

const THEME_KEY = "sas:theme";

function readTheme() {
  if (typeof window === "undefined") return "light";
  const t = localStorage.getItem(THEME_KEY);
  if (t === "light" || t === "dark") return t;
  // Migrate the Phase-1 key if present
  const legacy = localStorage.getItem("sas_theme");
  if (legacy === "light" || legacy === "dark") {
    localStorage.setItem(THEME_KEY, legacy);
    localStorage.removeItem("sas_theme");
    return legacy;
  }
  return "light";
}

const ThemeContext = createContext({ theme: "light", toggle: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(readTheme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(theme === "dark" ? "dark" : "light");
    try { localStorage.setItem(THEME_KEY, theme); } catch (_) {}
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, toggle, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
